import { State } from "../types/redux";
import { ENTITIES } from "../utils/data";
import { visibility, randomDate } from "../utils/genData";

export default (dataId: string): State | undefined => {
  return data[dataId];
};

// Example url
// http://localhost:19006/?dataId=example_data0&username=AaronXYZ

const data: { [key: string]: State } = {
  example_data0: {
    entity: "public",
    user: {
      name: "GeoffreyXYZ",
      image: "https://www.topgear.com/sites/default/files/2022/07/5_1.jpg",
    },
    watchlist: [
      {
        id: "WatchlistID-abc",
        insightID: "InsightID-XYZ",
        entity: "facebook",
      },
    ],
    insights: [
      {
        id: "InsightID-XYZ",
        title: "wow cool title!",
        date: randomDate(),
        visibilities: ENTITIES.map((e) => visibility(e)),
        tasks: [
          {
            entity: "friends",
            text: "Example task that you have to do",
            threshold: 30,
          },
        ],
        observations: [
          {
            entity: "amazon",
            text: "Example observation",
            date: randomDate(),
          },
          {
            entity: undefined,
            text: "Example observation without an entity",
            date: randomDate(),
          },
        ],
        visualisation: { type: "bar", data: [50, 100] },
        relatedInsights: ["InsightID-XYZ123"],
      },
      {
        id: "InsightID-XYZ123",
        title: "Insight number 2!",
        date: randomDate(),
        visibilities: ENTITIES.map((e) => visibility(e)),
        tasks: [
          {
            entity: "amazon",
            text: "Example task that you have to do from another insight",
            threshold: 30,
          },
        ],
        observations: [
          {
            entity: "facebook",
            text: "Example observation",
            date: randomDate(),
          },
          {
            entity: undefined,
            text: "Example observation without an entity",
            date: randomDate(),
          },
        ],
        visualisation: { type: "percentage", data: 30 },
        relatedInsights: [],
      },
    ],
    bottomSheet: undefined,
    stories: [],
  },
  randomid2: {
    entity: "public",
    user: {
      name: "NaTHAn",
      image: "https://www.topgear.com/sites/default/files/2022/07/5_1.jpg",
    },
    watchlist: [
      {
        id: "WatchlistID-abc",
        insightID: "InsightID-XYZ",
        entity: "facebook",
      },
    ],
    insights: [
      {
        id: "InsightID-XYZ",
        title: "Okay random id2!",
        date: randomDate(),
        visibilities: ENTITIES.map((e) => visibility(e)),
        tasks: [
          {
            entity: "friends",
            text: "Example task that you have to do",
            threshold: 30,
          },
        ],
        observations: [
          {
            entity: "amazon",
            text: "Example observation",
            date: randomDate(),
          },
          {
            entity: undefined,
            text: "Example observation without an entity",
            date: randomDate(),
          },
        ],
        visualisation: { type: "bar", data: [50, 100] },
        relatedInsights: ["InsightID-XYZ123"],
      },
      {
        id: "InsightID-XYZ123",
        title: "no way random 2",
        date: randomDate(),
        visibilities: ENTITIES.map((e) => visibility(e)),
        tasks: [
          {
            entity: "amazon",
            text: "Example task that you have to do from another insight",
            threshold: 30,
          },
        ],
        observations: [
          {
            entity: "facebook",
            text: "Example observation",
            date: randomDate(),
          },
          {
            entity: undefined,
            text: "Example observation without an entity",
            date: randomDate(),
          },
        ],
        visualisation: { type: "percentage", data: 30 },
        relatedInsights: [],
      },
    ],
    bottomSheet: undefined,
    stories: [],
  },
};
